import React from "react";

const SectionDivider = ({ label }) => (
  <div
    className="relative max-w-7xl mx-auto px-5 lg:px-10 mt-24 lg:mt-28"
    aria-hidden="true"
    data-testid="section-divider"
  >
    <div className="flex items-center gap-5">
      <span
        style={{
          height: 1,
          flex: 1,
          background:
            "linear-gradient(90deg, transparent, rgba(127,166,255,0.35), transparent)",
        }}
      />
      <span
        className="font-display"
        style={{
          fontSize: 18,
          letterSpacing: "0.36em",
          color: "var(--lt-text-mute)",
          padding: "0 12px",
          fontWeight: 600,
          textTransform: "uppercase",
        }}
      >
        {label || "LUTROM"}
      </span>
      <span
        style={{
          height: 1,
          flex: 1,
          background:
            "linear-gradient(90deg, transparent, rgba(127,166,255,0.35), transparent)",
        }}
      />
    </div>
  </div>
);

export default SectionDivider;
